import { writable } from 'svelte/store'
import { type UserNotification } from '@coso/core/realtime/types'
import { ulid } from 'ulid'

const store = writable<Record<string, UserNotification>>({})

function append(payload: UserNotification) {
  store.update((items) => ({ ...items, [ulid()]: payload }))
}

function remove(key: string) {
  store.update((items) => {
    delete items[key]
    return items
  })
}

function clear() {
  store.set({})
}

export const userNotifications = {
  subscribe: store.subscribe,
  set: store.set,
  update: store.update,
  append,
  remove,
  clear,
}

export default userNotifications
